export default "__VITE_ASSET__DI_ABQLW__"